import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormGroup, Validators, UntypedFormBuilder } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NgProgressRef, NgProgress } from 'ngx-progressbar';
import { Subscription } from 'rxjs';
import { Lang, Res } from 'src/app/models';
import { OrgDepartmentsDataActions, OrgDepartmentsReference } from 'src/app/models/org-departments.model';
import { ApiOrgDepartmentsService, LanguageService, NotificationService, ValidatorsService } from 'src/app/services';
import { OrgRoleEditValidator } from '../org-role-edit/org-role-edit.validation';

@Component({
  selector: 'app-org-departments-actions',
  templateUrl: './org-departments-actions.component.html',
  styleUrls: ['./org-departments-actions.component.css']
})
export class OrgDepartmentsActionsComponent implements OnInit {

  progressRef: NgProgressRef;
  subscriptions: Subscription = new Subscription();
  language: string;
  errorMessages: any;
  loading: boolean;
  departmentsData: OrgDepartmentsDataActions;
  departmentsReference: OrgDepartmentsReference;
  departmentId: string;
  departmentName: Lang;
  userData: any;

  ffInputLangParams = {
    name: {
      clearField: true,
      required: true
    }
  }

  form: UntypedFormGroup = this.fb.group({
    id: [null],
    name: [null, Validators.required],
    parent_id: [null]
  });

  @Input() set data(value) {

    if (value != null) {
      this.departmentId = value.department_id;
    }
  }

  constructor(
    public ngProgress: NgProgress,
    public activeModal: NgbActiveModal,
    private fb: UntypedFormBuilder,
    private languageService: LanguageService,
    private notification: NotificationService,
    private apiOrgDepartments: ApiOrgDepartmentsService,
    private validator: OrgRoleEditValidator,
    private validatorService: ValidatorsService
  ) { }

  ngOnInit(): void {

    this.progressRef = this.ngProgress.ref('progress-bar');
    this.errorMessages = this.validator.errorMessages;

    this.getDepartments();

    if(this.departmentId != null){
      this.onEdit();
    }

    this.subscriptions.add(
      this.languageService.listenerLanguage().subscribe(val => {

        this.language = val.language;
      })
    );
  }

  ngOnDestroy(): void {

    this.subscriptions.unsubscribe();
  }

  /**
  * 
  * @param fieldName string
  * @param value Lang
  */
  eventFnFF(fieldName: string, value: Lang): void {

    this.form.controls[fieldName].setValue(value);
  }

  /**
   * 
   * @param searchValue 
   */
  getDepartments(searchValue: string = ''): void {

    this.progressRef.start();
    this.loading = true;

    let params = {
      "filter": {}
    }

    this.subscriptions.add(
      this.apiOrgDepartments.getReferences(params, 'orgs_departments').subscribe((response: Res) => {

        if (response != null) {

          this.departmentsReference = response.result;
          if(this.userData) this.form.controls.department_id.setValue(this.userData.department);
        }
        this.progressRef.complete();
        this.loading = false;
      },
        error => {
          this.progressRef.complete();
          this.loading = false;
        })
    );
  }

    /**
     * 
     */
    onCreate(): void {

      let form = { ...this.form.value }
  
      this.progressRef.start();
  
      this.subscriptions.add(
        this.apiOrgDepartments.create(form).subscribe((response: Res) => {
  
          if (response != null) {
  
            this.notification.show('success', 'Роль успешно создана!');
            this.activeModal.close(response);
          }
  
          this.progressRef.complete();
        },
          error => {
            this.progressRef.complete();
          })
      );
    }


  /**
  * 
  */
   onEdit(): void {

    this.progressRef.start();
    this.loading = true;

    this.subscriptions.add(

      this.apiOrgDepartments.edit(this.departmentId).subscribe((response: Res) => {
        console.log('[RESPONSE] ORG_ROLE_EDIT: ', response);

        if (response != null) {

          this.departmentsData = { ...response.result };

          this.setDataInForm(response.result);
        }
        this.progressRef.complete();
        this.loading = false;
      },
        error => {
          this.progressRef.complete();
          this.loading = false;
        })
    );
  }

  
  /**
   * 
   */
   setDataInForm(data: any): any {
    
    this.departmentName = data.name;

    this.form.controls.id.setValue(data.id);
    this.form.controls.department_id.setValue(data.parent_id);
  }


  /**
   * 
   */
  onUpdate() {

    let form = { ...this.form.value }

    this.progressRef.start();

    this.subscriptions.add(
      this.apiOrgDepartments.update(form).subscribe((response: Res) => {
        console.log('[RESPONSE] updateUserInfo: ', response);

        if (response != null) {

          this.notification.show('success', 'Данные успешно сохранены!');
          this.activeModal.close(true);
        }

        this.progressRef.complete();
      },
        error => {
          this.progressRef.complete();
        })
    );
  }

  /**
  * 
  * @param field 
  * @param type 
  */
  validation(field: string, type: string): boolean {

    return this.validatorService.validation(this.form.get(field), type);
  }


}
